import _ from 'underscore';

import container from "../../libs/container/container";

import loadMoreFactory from "../../libs/load/load-more";
import lightboxFactory from '../../libs/lightbox/lightbox';
import jumpFactory from '../../libs/jump/jump';
import preloader from "../../libs/preloader/preloader";

import binder from "../../libs/utils/binder";
import $ from "jquery";

const amdTopicsListingModule = (function () {
    const name = 'topics__listing-module';

    const view = container.getBaseView(name);

    view.privateVars = {
        criteria: {
            series: 'all',
            sort: 'latest'
        },
        prevCriteria: null,
        scrollBoxesRegistered: [],
        preloadedImages: []
    };

    view.service = {
        lightbox: null,
        jump: null,
        loadMore: null,
        preloader: preloader
    };

    view.startup = function () {
        view.service.loadMore = loadMoreFactory.create();
        view.service.loadMore.init(view.publicVars.loadMoreSetup);

        view.service.jump = jumpFactory.create();

        view.service.lightbox = lightboxFactory.create();
        view.service.lightbox.init(view.publicVars.lightboxSetup);

        view.service.lightbox.setCloseCallback(function () {
            document.querySelector('html').classList.remove(view.publicVars.cssId.filtersLightboxOpenCls.substring(1));
            document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.remove(view.publicVars.cssId.filterLightboxEnableScrollCls.substring(1));
            document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.remove(view.publicVars.cssId.filterLightboxEnableTopPositionCls.substring(1));
        });

        view.service.lightbox.setPreCloseCallback(() => {
            document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.remove(view.publicVars.cssId.filterLightboxEnableScrollCls.substring(1));
        });

        if(document.querySelector(view.publicVars.cssId.anim.moduleTopicsListingLoadMoreCls)) {
            container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsListingLoadMoreCls, 'animate__fadeInUp50P', name, {
                dynamicPosHeight: true
            });
        }

        view.methods.registerScrollBoxes();

        view.service.loadMore.setSuccessCallback(() => {
            view.methods.registerScrollBoxes();
        });
    };

    view.bind = function () {

        let resizeRAF;

        document.querySelector(view.publicVars.cssId.jsFiltersLightboxCallCls).addEventListener('click', () => {
            view.methods.callFiltersLightbox();
        });

        window.addEventListener('resize', function () {
            cancelAnimationFrame(resizeRAF);

            resizeRAF = requestAnimationFrame(function () {
                if (view.service.lightbox.getStatus() === 1) {
                    view.methods.configureLightboxPosition();
                }
            });
        });

        window.addEventListener('orientationchange', function () {
            cancelAnimationFrame(resizeRAF);

            resizeRAF = requestAnimationFrame(function () {
                if (view.service.lightbox.getStatus() === 1) {
                    view.methods.configureLightboxPosition();
                }
            });
        });

        binder.bindToAll('click', view.publicVars.cssId.filtersLightboxSearchSeriesItemCls, function () {
            if(view.privateVars.criteria.series !== this.dataset.search) {
                view.methods.selectSearchSeriesFilter(this.dataset.search, this);
            }
        });

        binder.bindToAll('click', view.publicVars.cssId.filtersLightboxSortItemCls, function () {
            if(view.privateVars.criteria.sort !== this.dataset.sort) {
                view.methods.selectSortFilter(this.dataset.sort, this);
            }
        });

        document.querySelector(view.publicVars.cssId.filtersLightboxSubmitFiltersCls).addEventListener('click', () => {
            view.methods.submitFilters();
        });
    };

    view.methods = {

        registerScrollBoxes: function () {
            const topicBoxes = document.querySelectorAll(view.publicVars.cssId.anim.moduleTopicsListingItemCls);

            topicBoxes.forEach((item) => {

                const id = container.getData(item, 'id');

                if(!view.privateVars.scrollBoxesRegistered.includes(view.publicVars.cssId.anim.moduleTopicsListingItemCls + id)) {
                    container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsListingItemCls + id, 'animate__zoomIn50P', name, {
                        dynamicPosHeight: true
                    });
                    view.privateVars.scrollBoxesRegistered.push(view.publicVars.cssId.anim.moduleTopicsListingItemCls + id);
                }
            });
        },

        refreshScrollBoxes: function () {
            for(let i = 0; i < view.privateVars.scrollBoxesRegistered.length; i++) {
                container.getService('scroll').unregisterAnimatedElement(view.privateVars.scrollBoxesRegistered[i]);
            }

            view.privateVars.scrollBoxesRegistered = [];

            view.methods.registerScrollBoxes();
        },

        callFiltersLightbox: function () {

            document.querySelector('html').classList.add(view.publicVars.cssId.filtersLightboxOpenCls.substring(1));

            document.querySelector(view.publicVars.cssId.filtersLightboxAreaId).style.display = 'block';

            const windowHeight = document.documentElement.clientHeight;
            const lightboxHeight = document.querySelector(view.publicVars.cssId.filtersLightboxCls).offsetHeight;


            if(windowHeight < lightboxHeight) {
                document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.add(view.publicVars.cssId.filterLightboxEnableTopPositionCls.substring(1));
            }

            view.service.lightbox.showLayer(() => {

                view.privateVars.prevCriteria = {...view.privateVars.criteria};

                if(windowHeight < lightboxHeight) {
                    document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.add(view.publicVars.cssId.filterLightboxEnableScrollCls.substring(1));
                }
            });
        },

        configureLightboxPosition: function () {
            const windowHeight = document.documentElement.clientHeight;
            const lightboxHeight = document.querySelector(view.publicVars.cssId.filtersLightboxCls).offsetHeight;

            document.querySelector(view.publicVars.cssId.filtersLightboxAreaId).style.display = 'block';

            if (windowHeight <= lightboxHeight) {
                document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.add(view.publicVars.cssId.filterLightboxEnableTopPositionCls.substring(1));
                document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.add(view.publicVars.cssId.filterLightboxEnableScrollCls.substring(1));
            } else {
                document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.remove(view.publicVars.cssId.filterLightboxEnableTopPositionCls.substring(1));
                document.querySelector(view.publicVars.cssId.filtersLightboxCls).classList.remove(view.publicVars.cssId.filterLightboxEnableScrollCls.substring(1));
            }
        },

        selectSearchSeriesFilter: (search, handle) => {

            binder.executeForAll(view.publicVars.cssId.filtersLightboxSearchSeriesItemCls, (item) => {
                item.classList.remove(view.publicVars.cssId.isActiveCls.substring(1));
            });

            handle.classList.add(view.publicVars.cssId.isActiveCls.substring(1));

            view.privateVars.criteria.series = search;

            container.msg(name, 'selected series: ' + search);
        },

        selectSortFilter: (sort, handle) => {

            binder.executeForAll(view.publicVars.cssId.filtersLightboxSortItemCls, (item) => {
                item.classList.remove(view.publicVars.cssId.isActiveCls.substring(1));
            });

            handle.classList.add(view.publicVars.cssId.isActiveCls.substring(1));

            view.privateVars.criteria.sort = sort;

            container.msg(name, 'selected sort: ' + sort);
        },

        submitFilters: () => {
            if(view.privateVars.criteria.series !== view.privateVars.prevCriteria.series
                || view.privateVars.criteria.sort !== view.privateVars.prevCriteria.sort) {

                view.service.loadMore.setAdditionalParamCallback(() => {
                    return '' + view.privateVars.criteria.series + '/' + view.privateVars.criteria.sort;
                });

                document.querySelector(view.publicVars.cssId.moduleTopicsListingGridWrapperCls).classList.add(view.publicVars.cssId.isLoadingCls.substring(1));
                document.querySelector(view.publicVars.cssId.moduleTopicsListingLoadMoreId).classList.remove(view.publicVars.cssId.moduleTopicsListingLoadMoreAllLoadedCls.substring(1));
                document.querySelector(view.publicVars.cssId.moduleTopicsListingLoadMoreBtnWrapperCls).removeAttribute('style');

                container.msg(name, 'submitting filters');

                view.service.jump.centerTo(view.publicVars.cssId.moduleTopicsListingGridLoaderWrapperCls, async () => {
                    const response = await fetch(view.publicVars.ajaxFiltersEndpoint
                        + '/' + view.publicVars.filtersOffset + '/' + view.publicVars.filtersLimit + '/'
                        + view.privateVars.criteria.series + '/' + view.privateVars.criteria.sort);

                    const data = await response.json();

                    const compiled = _.template(document.getElementById(view.publicVars.cssId.templateId.substring(1)).innerHTML);

                    const output = compiled({
                        data: data
                    });

                    view.service.loadMore.reset(data.count_all);

                    let itemsImages = [];

                    data.items.forEach((item) => {
                        if(!view.privateVars.preloadedImages.includes(item.thumb)) {
                            view.privateVars.preloadedImages.push(item.thumb);
                            itemsImages.push(item.thumb);
                        }
                    });

                    const currentTimestamp = new Date().getTime();

                    view.service.preloader.setPreloadBulk(name + currentTimestamp, itemsImages);

                    view.service.preloader.getPreloadBulkFinished(name + currentTimestamp, () => {
                        setTimeout(() => {
                            document.querySelector(view.publicVars.cssId.moduleTopicsListingGridLoaderWrapperCls).style.opacity = 0;

                            document.querySelector(view.publicVars.cssId.moduleTopicsListingGridCls).innerHTML = output;

                            document.querySelector(view.publicVars.cssId.moduleTopicsListingGridWrapperCls).classList.remove(view.publicVars.cssId.isLoadingCls.substring(1));

                            if (data.count_all <= data.limit) {
                                container.msg(name, 'all loaded');
                                document.querySelector(view.publicVars.cssId.moduleTopicsListingLoadMoreId).classList.add(view.publicVars.cssId.moduleTopicsListingLoadMoreAllLoadedCls.substring(1));
                            } else {
                                container.msg(name, 'load more needed');
                                document.querySelector(view.publicVars.cssId.moduleTopicsListingLoadMoreId).classList.remove(view.publicVars.cssId.moduleTopicsListingLoadMoreAllLoadedCls.substring(1));
                                document.querySelector(view.publicVars.cssId.moduleTopicsListingLoadMoreBtnWrapperCls).removeAttribute('style');
                            }

                            const headerHeight = -document.querySelector(view.publicVars.cssId.headerCls).offsetHeight;

                            view.service.jump.jumpTo(view.publicVars.cssId.moduleTopicsListingGridWrapperCls, {
                                modifier: headerHeight,
                                speed: 0
                            }, () => {
                                document.querySelector(view.publicVars.cssId.moduleTopicsListingGridLoaderWrapperCls).removeAttribute('style');

                                view.methods.refreshScrollBoxes();
                                container.getService('scroll').refreshScroll();
                            });

                        }, 500);
                    });

                });

                view.service.lightbox.close();

            } else {
                view.service.lightbox.close();
            }
        }
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdTopicsListingModule;